/**
 * admin/dashboard actions and admin/shared actions must be explicitly imported.
 */
import * as activeTickets from 'actions/ActiveTicketsActions';
import * as announcements from 'actions/AnnouncementsActions';
import * as app from 'actions/AppActions';
import * as availability from 'actions/AvailabilityActions';
import * as bank from 'actions/BankActions';
import * as batch from 'actions/BatchActions';
import * as blocks from 'actions/BlocksActions';
import * as booking from 'actions/BookingActions';
import * as bookingModal from 'actions/BookingModalActions';
import * as business from 'actions/BusinessActions';
import * as businessInventory from 'actions/BusinessInventory';
import * as businessProfile from 'actions/BusinessProfileActions';
import * as businessRoles from 'actions/BusinessRolesActions';
import * as businessServer from 'actions/BusinessServerActions';
import * as calendar from 'actions/CalendarActions';
import * as calendarFilter from 'actions/CalendarFilterActions';
import * as checkForcedLogout from 'actions/CheckForcedLogoutActions';
import * as checkin from 'actions/CheckinActions';
import * as chits from 'actions/ChitActions';
import * as closedDays from 'actions/ClosedDaysActions';
import * as communication from 'actions/CommunicationActions';
import * as cookieConsent from '@tock/shared/actions/CookieConsentActions';
import * as csrfTokenActions from '@tock/shared/actions/CsrfTokenActions';
import * as dashboardPreferences from 'actions/DashboardPreferenceActions';
import * as dayNotes from 'actions/DayNotesActions';
import * as delivery from 'actions/DeliveryActions';
import * as elmApp from 'actions/service/elm/appActions';
import * as elmParties from 'actions/service/elm/partiesActions';
import * as elmServers from 'actions/service/elm/serversActions';
import * as elmTableTag from 'actions/service/elm/tableTagActions';
import * as elmTables from 'actions/service/elm/tablesActions';
import * as exports from 'actions/ExportActions';
import * as facebook from 'actions/FacebookActions';
import * as features from 'actions/FeaturesActions';
import * as financialReports from 'actions/FinancialReportsActions';
import * as flexCalendarSections from 'actions/FlexCalendarSectionActions';
import * as floorplan from 'actions/FloorplanActions';
import * as flowTrack from 'actions/FlowTrackActions';
import * as guestGroups from 'actions/GuestGroupsActions';
import * as guestIntegrations from 'actions/GuestIntegrationActions';
import * as guestList from 'actions/GuestListActions';
import * as guestProfile from 'actions/GuestProfileActions';
import * as handsell from 'actions/HandSellActions';
import * as helpMenu from 'actions/HelpMenuActions';
import * as hubLanding from 'actions/HubLandingActions';
import * as image from 'actions/ImageActions';
import * as inventoryScheduleHistory from '@tock/shared/actions/InventoryScheduleHistoryActions';
import * as inventoryScheduleUpdateWorkflows from 'actions/InventoryScheduleUpdateWorkflows';
import * as inventorySchedules from 'actions/InventoryScheduleActions';
import * as invoices from 'actions/reporting/InvoicesReportActions';
import * as keyboardShortcuts from 'actions/KeyboardShortcutActions';
import * as loyaltyProgram from 'actions/LoyaltyProgramActions';
import * as menu from 'actions/MenuActions';
import * as metaTag from 'actions/MetaTagActions';
import * as networkPrinters from 'actions/NetworkPrintersActions';
import * as oauthActions from 'actions/OAuthActions';
import * as onboarding from 'actions/OnboardingActions';
import * as onlineWalkinWaitlist from 'actions/OnlineWalkinWaitlistActions';
import * as optionSelectors from 'actions/OptionSelectorsActions';
import * as options from 'actions/OptionsActions';
import * as orderNotifications from 'actions/OrderNotificationsActions';
import * as pacing from 'actions/PacingActions';
import * as packages from 'actions/PackagesActions';
import * as passcodeConfig from 'actions/PasscodeConfigActions';
import * as patron from 'actions/PatronActions';
import * as patronPasscodes from 'actions/PatronPasscodesActions';
import * as patronSearch from 'actions/PatronSearchActions';
import * as patronStats from 'actions/PatronStatsActions';
import * as paymentCard from '@tock/shared/actions/PaymentCardActions';
import * as payoutsReport from 'actions/reporting/PayoutsReportActions';
import * as persistedUi from 'actions/PersistedUiActions';
import * as pointOfSale from 'actions/PosActions';
import * as publicHours from 'actions/PublicHoursActions';
import * as purchase from 'actions/PurchaseActions';
import * as questions from 'actions/QuestionsActions';
import * as rebalancing from 'actions/RebalancingActions';
import * as reschedule from 'actions/RescheduleActions';
import * as reservation from 'actions/ReservationActions';
import * as reservationFilter from 'actions/ReservationFilterActions';
import * as reservations from 'actions/ReservationsActions';
import * as reservationsSidePanel from 'actions/ReservationsSidePanelActions';
import * as savedPrinters from 'actions/SavedPrintersActions';
import * as schedule from 'actions/ScheduleActions';
import * as serviceConfig from 'actions/ServiceConfigActions';
import * as serviceReports from 'actions/ServiceReportsActions';
import * as serviceUiActions from 'actions/service/ui/serviceActions';
import * as serviceUiBusinessServer from 'actions/service/ui/businessServerActions';
import * as serviceUiFloor from 'actions/service/ui/floorActions';
import * as serviceUiModal from 'actions/service/ui/modalActions';
import * as serviceUiPanel from 'actions/service/ui/panelActions';
import * as serviceUiPartyDisplay from 'actions/service/ui/partyDisplayActions';
import * as serviceUiPartyList from 'actions/service/ui/partyListActions';
import * as serviceUiSettings from 'actions/service/ui/settingsActions';
import * as serviceUiSidebarTab from 'actions/service/ui/sidebarTabActions';
import * as serviceUiTable from 'actions/service/ui/tableActions';
import * as serviceUiTableCombinations from 'actions/service/ui/tableCombinationActions';
import * as serviceUiWaitlist from 'actions/service/ui/waitlistActions';
import * as serviceUiWalkIn from 'actions/service/ui/walkInActions';
import * as services from 'actions/ServicesActions';
import * as shopOrders from 'actions/ShopOrderActions';
import * as support from 'actions/SupportActions';
import * as tableCombination from 'actions/TableCombinationActions';
import * as tableEdits from 'actions/TableEditActions';
import * as tables from 'actions/TablesActions';
import * as tags from 'actions/TagsActions';
import * as templateInfo from 'actions/TemplateInfoActions';
import * as templateSections from 'actions/TemplateSectionActions';
import * as templates from 'actions/TemplatesActions';
import * as texting from 'actions/TextingActions';
import * as ticketGroups from 'actions/TicketGroupsActions';
import * as tickets from 'actions/TicketsActions';
import * as tockApiKey from 'actions/TockApiKeyActions';
import * as tos from 'actions/ToSActions';
import * as turnTimes from 'actions/TurnTimesActions';
import * as ui from 'actions/UIActions';
import * as waitlist from 'actions/WaitlistActions';
import * as waitlistReport from 'actions/WaitlistReportActions';
import { actions as toast } from '@tock/toast';

export const actions = {
  elmApp,
  elmParties,
  elmServers,
  elmTables,
  elmTableTag,
  serviceUiActions,
  serviceUiBusinessServer,
  serviceUiFloor,
  serviceUiModal,
  serviceUiPanel,
  serviceUiPartyDisplay,
  serviceUiPartyList,
  serviceUiSettings,
  serviceUiSidebarTab,
  serviceUiTable,
  serviceUiWalkIn,
  serviceUiTableCombinations,
  serviceUiWaitlist,
  activeTickets,
  announcements,
  app,
  availability,
  bank,
  batch,
  blocks,
  booking,
  bookingModal,
  business,
  businessInventory,
  businessProfile,
  businessRoles,
  businessServer,
  calendar,
  calendarFilter,
  checkin,
  checkForcedLogout,
  chits,
  closedDays,
  cookieConsent,
  csrfTokenActions,
  communication,
  dashboardPreferences,
  dayNotes,
  delivery,
  exports,
  facebook,
  features,
  financialReports,
  flexCalendarSections,
  floorplan,
  flowTrack,
  guestGroups,
  guestIntegrations,
  guestList,
  guestProfile,
  handsell,
  helpMenu,
  hubLanding,
  image,
  invoices,
  inventorySchedules,
  inventoryScheduleHistory,
  inventoryScheduleUpdateWorkflows,
  keyboardShortcuts,
  loyaltyProgram,
  menu,
  metaTag,
  networkPrinters,
  oauthActions,
  onlineWalkinWaitlist,
  onboarding,
  options,
  optionSelectors,
  orderNotifications,
  pacing,
  packages,
  passcodeConfig,
  patron,
  patronPasscodes,
  patronSearch,
  patronStats,
  paymentCard,
  payoutsReport,
  persistedUi,
  pointOfSale,
  publicHours,
  purchase,
  questions,
  rebalancing,
  reschedule,
  reservation,
  reservations,
  reservationFilter,
  reservationsSidePanel,
  savedPrinters,
  schedule,
  serviceConfig,
  serviceReports,
  services,
  shopOrders,
  support,
  tableCombination,
  tableEdits,
  tables,
  tags,
  templateInfo,
  templates,
  templateSections,
  texting,
  ticketGroups,
  tickets,
  toast,
  tockApiKey,
  tos,
  turnTimes,
  ui,
  waitlist,
  waitlistReport,
};

export interface AllActions {
  payoutsReport: payoutsReport.PayoutsReportActions;
  checkinActions: checkin.CheckinActions;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [actionName: string]: any;
}
